import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImportComponent } from 'src/app/developer/import/import.component';

@Component({
  templateUrl: './test-tool-compare-rules-import.component.html',
  styleUrl: './test-tool-compare-rules-import.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ImportComponent]
})
export class TestToolCompareRulesImportComponent {
}
